var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "row h-100 d-flex flex-column flex-nowrap" },
    [
      _setup.subscription && _setup.subscription.Id
        ? _c(_setup.SubscriptionPauseCancelDialog, {
            attrs: {
              "subscription-id": _setup.subscription.Id,
              "allow-pausing": !_setup.subscriptionPausedOrWillPause,
              "allow-canceling": _setup.cancelPauseDialogAllowCancel,
              "account-disable-mode": _setup.accountDisableMode,
              store: _setup.storeUrl,
              "card-token": _setup.pauseCardToken,
            },
            on: {
              canceled: _setup.onSubscriptionCancel,
              paused: _setup.onSubscriptionPaused,
            },
            model: {
              value: _setup.showSubscriptionPauseCancelDialog,
              callback: function ($$v) {
                _setup.showSubscriptionPauseCancelDialog = $$v
              },
              expression: "showSubscriptionPauseCancelDialog",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.subscription && _setup.subscription.Id
        ? _c(_setup.SubscriptionResumeDialog, {
            attrs: {
              "subscription-id": _setup.subscription.Id,
              store: _setup.storeUrl,
            },
            on: { resumed: _setup.onSubscriptionResumed },
            model: {
              value: _setup.showSubscriptionResumeDialog,
              callback: function ($$v) {
                _setup.showSubscriptionResumeDialog = $$v
              },
              expression: "showSubscriptionResumeDialog",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "mt-3",
          attrs: {
            size: "lg",
            title: "Update billing",
            "modal-class": "vue-need-bootstrap",
            lazy: "",
            centered: "",
            "hide-footer": "",
            "no-close-on-backdrop": "",
          },
          model: {
            value: _setup.showUpdateCardDialog,
            callback: function ($$v) {
              _setup.showUpdateCardDialog = $$v
            },
            expression: "showUpdateCardDialog",
          },
        },
        [
          _c(_setup.CreditCardInput, {
            attrs: {
              "stripe-public-key": _setup.stripePublicKey,
              store: _setup.storeUrl,
            },
            on: { "card-updated": _setup.onCardSubmit },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "mt-3",
          attrs: {
            size: "lg",
            title: "Enter card",
            "modal-class": "vue-need-bootstrap",
            lazy: "",
            centered: "",
            "hide-footer": "",
            "no-close-on-backdrop": "",
          },
          model: {
            value: _setup.showCardAskDialog,
            callback: function ($$v) {
              _setup.showCardAskDialog = $$v
            },
            expression: "showCardAskDialog",
          },
        },
        [
          _c(_setup.CreditCardInput, {
            attrs: {
              "no-save": true,
              "stripe-public-key": _setup.stripePublicKey,
              store: _setup.storeUrl,
            },
            on: { token: _setup.onCardForPauseSubmit },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(_setup.StoreSelector, {
        attrs: { stores: _setup.userStores },
        on: { input: _setup.setStoreUrl },
      }),
      _vm._v(" "),
      _setup.subscription
        ? _c(_setup.CustomilyPlanCard, {
            attrs: {
              loading: _setup.loadingSubscriptions,
              store: _setup.storeUrl,
              subscription: _setup.subscription,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_setup.isShopifyNewPlan
        ? _c("div", [
            _c("div", { staticClass: "mt-3" }, [
              _c("div", { staticClass: "card white-card shadow-sm" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("h4", { staticClass: "card-title mb-3" }, [
                    _vm._v("Billing Details"),
                  ]),
                  _vm._v(" "),
                  _c("div", { class: { busy: _setup.loadingPaymentMethod } }, [
                    _setup.loadingPaymentMethod
                      ? _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c("b-spinner", {
                              staticClass: "my-2",
                              attrs: { variant: "primary" },
                            }),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "row small-card-content",
                            class: {
                              "has-card":
                                _setup.paymentMethod &&
                                _setup.subscription &&
                                _setup.customer,
                            },
                          },
                          [
                            _c("div", { staticClass: "col-10 row" }, [
                              _c("div", { staticClass: "col-6" }, [
                                _setup.paymentMethod &&
                                _setup.subscription &&
                                _setup.customer
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "align-items-center d-flex",
                                      },
                                      [
                                        _c(_setup.CardIcon, {
                                          staticClass: "d-inline",
                                          attrs: {
                                            card: _setup.paymentMethod.Brand,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("div", [
                                          _c(
                                            "h5",
                                            { staticClass: "d-inline ml-2" },
                                            [
                                              _vm._v(
                                                "Card ending in " +
                                                  _vm._s(
                                                    _setup.paymentMethod.Last4
                                                  )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "small",
                                            {
                                              staticClass:
                                                "card-expiration card-expiration ml-1",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                exp. " +
                                                  _vm._s(
                                                    _setup.paymentMethod.ExpMonth.toString().padStart(
                                                      2,
                                                      "0"
                                                    )
                                                  ) +
                                                  " /" +
                                                  _vm._s(
                                                    _setup.paymentMethod.ExpYear
                                                  ) +
                                                  "\n                                            "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_setup.paymentMethod &&
                                _setup.subscription &&
                                _setup.customer
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "align-items-center d-flex",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        No credit card added.\n                                    "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_setup.subscription || !_setup.customer
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "align-items-center d-flex",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        You don't have any active subscriptions. Please contact us.\n                                    "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _setup.customer && _setup.customer.Email
                                  ? _c("div", { staticClass: "mt-3" }, [
                                      _vm._v(
                                        "\n                                        Billing contact:\n                                        "
                                      ),
                                      _c("strong", [
                                        _vm._v(_vm._s(_setup.customer.Email)),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _setup.paymentMethod
                                ? _c("div", { staticClass: "col-6" }, [
                                    _c("ul", [
                                      _setup.paymentMethod.BillingDetails.Name
                                        ? _c("li", [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _setup.paymentMethod
                                                    .BillingDetails.Name
                                                ) +
                                                "\n                                        "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _setup.paymentMethod.BillingDetails
                                        .Address1
                                        ? _c("li", [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _setup.paymentMethod
                                                    .BillingDetails.Address1
                                                ) +
                                                "\n                                        "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _setup.paymentMethod.BillingDetails
                                        .Country &&
                                      _setup.paymentMethod.BillingDetails.City
                                        ? _c("li", [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _setup.paymentMethod
                                                    .BillingDetails.City
                                                ) +
                                                ",\n                                            " +
                                                _vm._s(
                                                  _setup.paymentMethod
                                                    .BillingDetails.Country
                                                ) +
                                                "\n                                            "
                                            ),
                                            _setup.paymentMethod.BillingDetails
                                              .State
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                                                ," +
                                                      _vm._s(
                                                        _setup.paymentMethod
                                                          .BillingDetails.State
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _setup.paymentMethod.BillingDetails
                                              .PostalCode
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                                                , " +
                                                      _vm._s(
                                                        _setup.paymentMethod
                                                          .BillingDetails
                                                          .PostalCode
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ])
                                        : _vm._e(),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _setup.subscription && _setup.customer
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col d-flex align-items-end justify-content-end",
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-primary",
                                        on: {
                                          click: function ($event) {
                                            return _setup.editCreditCard()
                                          },
                                        },
                                      },
                                      [_vm._v("Edit billing")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3 invoice-card" }, [
              _c("div", { staticClass: "card white-card shadow-sm h-100" }, [
                _c(
                  "div",
                  { staticClass: "card-body d-flex flex-column" },
                  [
                    _c("h4", { staticClass: "card-title mb-3" }, [
                      _vm._v("Billing History"),
                    ]),
                    _vm._v(" "),
                    _c("b-table", {
                      staticClass: "invoice-table flex-grow-1",
                      attrs: {
                        "sticky-header": "",
                        hover: "",
                        fixed: "",
                        "show-empty": "",
                        fields: _setup.invoiceTableFields,
                        items: _setup.invoiceItems,
                        busy: _setup.loadingInvoices,
                        "empty-text": "No invoices",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "empty",
                            fn: function (scope) {
                              return [
                                _c("div", { staticClass: "text-center mt-3" }, [
                                  _c("h5", [_vm._v(_vm._s(scope.emptyText))]),
                                ]),
                              ]
                            },
                          },
                          {
                            key: "table-busy",
                            fn: function () {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "align-items-center d-flex justify-content-center w-100 mt-3",
                                  },
                                  [
                                    _c("b-spinner", {
                                      staticClass: "my-2",
                                      attrs: { variant: "primary" },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "cell(date)",
                            fn: function (data) {
                              return [_c("div", [_vm._v(_vm._s(data.value))])]
                            },
                          },
                          {
                            key: "cell(description)",
                            fn: function () {
                              return [_c("div", [_vm._v("Customily Service")])]
                            },
                            proxy: true,
                          },
                          {
                            key: "cell(amount)",
                            fn: function (data) {
                              return [_c("div", [_vm._v(_vm._s(data.value))])]
                            },
                          },
                          {
                            key: "cell(status)",
                            fn: function (data) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-capitalize",
                                    class: {
                                      paid: data.value === "paid",
                                      "primary-text": data.value === "paid",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(data.value) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(invoice)",
                            fn: function (data) {
                              return [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: data.value,
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-eye invoice-icon",
                                    }),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1542366521
                      ),
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-center" },
                      [
                        _c("div", { staticClass: "btn-group" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-secondary btn-white shadow-none",
                              class: {
                                disabled:
                                  _setup.loadingInvoices ||
                                  _setup.disablePrevBtn,
                              },
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _setup.goPrevInvoicesPage()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                                ‹\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-secondary btn-white shadow-none",
                              class: {
                                disabled:
                                  _setup.loadingInvoices ||
                                  _setup.disableNextBtn,
                              },
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _setup.goNextInvoicesPage()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                                ›\n                            "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3" }, [
              _c("div", { staticClass: "card white-card shadow-sm" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("h4", { staticClass: "card-title mb-3" }, [
                    _vm._v(
                      "Pause " +
                        _vm._s(_setup.actionEntityStringCapitalized) +
                        " Subscription"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { class: { busy: _setup.loadingSubscriptions } }, [
                    _setup.loadingSubscriptions
                      ? _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c("b-spinner", {
                              staticClass: "my-2",
                              attrs: { variant: "primary" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_setup.loadingSubscriptions &&
                    _setup.subscription &&
                    _setup.hasActiveSubscription &&
                    !_setup.subscription.WillPauseAt &&
                    !_setup.subscription.WillCancelAt
                      ? _c("div", { staticClass: "row small-card-content" }, [
                          _c(
                            "div",
                            { staticClass: "col-8" },
                            [
                              _vm._v(
                                "\n                                You can pause your subscription and save all your template and options information\n                                to use it on your products later on "
                              ),
                              _c("strong", [_vm._v("for $5 a month")]),
                              _vm._v(
                                ". Your products\n                                will no longer have options and previews live, but all your work will be saved so\n                                you can come back whenever you are ready and activate them.\n\n                                "
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _setup.subscription.Status === "past_due"
                                ? [
                                    _vm._v(
                                      "\n                                    If you pause your subscription,\n                                    "
                                    ),
                                    _c("strong", [
                                      _vm._v(
                                        "Customily will immediately stop working on your store."
                                      ),
                                    ]),
                                  ]
                                : [
                                    _vm._v(
                                      "\n                                    If you pause your subscription, Customily will work on your store until the end\n                                    of your billing period:\n                                    "
                                    ),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _setup.formatDateString(
                                            _setup.subscription.CurrentPeriodEnd
                                          )
                                        )
                                      ),
                                    ]),
                                  ],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col d-flex align-items-end justify-content-end",
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-secondary",
                                  on: {
                                    click: function ($event) {
                                      return _setup.startSubscriptionPauseFlow(
                                        _setup.subscription.Status ===
                                          "past_due"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                    Pause\n                                    " +
                                      _vm._s(_setup.actionEntityString) +
                                      " for $5/month\n                                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.subscription &&
                    (_setup.subscription.Status === "paused" ||
                      _setup.subscription.Status === "paused_past_due")
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-8" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_setup.actionEntityStringCapitalized) +
                                " is paused. To continue using our services please\n                                resume it.\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col d-flex align-items-end justify-content-end",
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  on: {
                                    click: function ($event) {
                                      return _setup.startSubscriptionResumeFlow()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                    Resume " +
                                      _vm._s(
                                        _setup.actionEntityStringCapitalized
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.subscription &&
                    _setup.hasActiveSubscription &&
                    _setup.subscription.WillPauseAt &&
                    !_setup.subscription.WillCancelAt
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-8" }, [
                            _vm._v(
                              "\n                                Your " +
                                _vm._s(_setup.actionEntityString) +
                                " will be paused on\n                                "
                            ),
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _setup.formatDateString(
                                    _setup.subscription.WillPauseAt
                                  )
                                )
                              ),
                            ]),
                            _vm._v(
                              "\n                                . You can avoid it by resuming your " +
                                _vm._s(_setup.actionEntityString) +
                                ".\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-8 d-flex align-items-end justify-content-end",
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  on: {
                                    click: function ($event) {
                                      return _setup.startSubscriptionResumeFlow()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                    Resume " +
                                      _vm._s(
                                        _setup.actionEntityStringCapitalized
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.subscription &&
                    _setup.hasActiveSubscription &&
                    _setup.subscription.WillCancelAt
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-8" }, [
                            _vm._v(
                              "\n                                Your " +
                                _vm._s(_setup.actionEntityString) +
                                " will be canceled on\n                                "
                            ),
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _setup.formatDateString(
                                    _setup.subscription.WillCancelAt
                                  )
                                )
                              ),
                            ]),
                            _vm._v(
                              "\n                                . You can avoid it by resuming your " +
                                _vm._s(_setup.actionEntityString) +
                                ".\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col d-flex align-items-end justify-content-end",
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  on: {
                                    click: function ($event) {
                                      return _setup.startSubscriptionResumeFlow()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                    Resume " +
                                      _vm._s(
                                        _setup.actionEntityStringCapitalized
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.subscription &&
                    _setup.subscription.Status === "canceled"
                      ? _c("div", [
                          _vm._v(
                            "\n                            Your " +
                              _vm._s(_setup.actionEntityString) +
                              " has been canceled. Please contact us if you wish to resume\n                            using our services.\n                        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_setup.subscription ||
                    (_setup.subscription &&
                      (_setup.subscription.Status === "unpaid" ||
                        _setup.subscription.Status === "incomplete" ||
                        _setup.subscription.Status === "incomplete_expired"))
                      ? _c("div", [
                          _vm._v(
                            "\n                            You don't have any active subscriptions. Please contact us.\n                        "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3 pb-3" }, [
              _c("div", { staticClass: "card white-card shadow-sm" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("h4", { staticClass: "card-title mb-3" }, [
                    _vm._v(
                      "Cancel " +
                        _vm._s(_setup.actionEntityStringCapitalized) +
                        " Subscription"
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { class: { busy: _setup.loadingSubscriptions } },
                    [
                      _setup.loadingSubscriptions
                        ? _c(
                            "div",
                            { staticClass: "text-center" },
                            [
                              _c("b-spinner", {
                                staticClass: "my-2",
                                attrs: { variant: "primary" },
                              }),
                            ],
                            1
                          )
                        : [
                            _setup.subscription &&
                            _setup.hasActiveSubscription &&
                            !_setup.subscription.WillCancelAt
                              ? _c(
                                  "div",
                                  { staticClass: "row small-card-content" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "col-8" },
                                      [
                                        !_setup.accountDisableMode
                                          ? _c("b", [
                                              _vm._v(
                                                "\n                                        If you cancel, all your templates, libraries, and personalization\n                                        information will be disconnected from your " +
                                                  _vm._s(
                                                    _setup.actionEntityString
                                                  ) +
                                                  "."
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _setup.accountDisableMode
                                          ? _c("b", [
                                              _vm._v(
                                                "\n                                        If you cancel, all your templates, libraries, and personalization\n                                        information will be lost."
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm._v(
                                          "\n\n                                    If you wish to save this information to use it in your " +
                                            _vm._s(_setup.actionEntityString) +
                                            "\n                                    again in the future you can\n                                    "
                                        ),
                                        _c("b", [
                                          _vm._v(
                                            "pause your " +
                                              _vm._s(
                                                _setup.actionEntityString
                                              ) +
                                              " instead."
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(" "),
                                        _setup.subscription.Status ===
                                        "past_due"
                                          ? [
                                              _vm._v(
                                                "\n                                        If you cancel your subscription,\n                                        "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  "Customily will immediately stop working on your store."
                                                ),
                                              ]),
                                            ]
                                          : [
                                              _vm._v(
                                                "\n                                        If you cancel your subscription, Customily will work on your store until the\n                                        end of your billing period:\n                                        "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _setup.formatDateString(
                                                      _setup.subscription
                                                        .CurrentPeriodEnd
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ],
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col d-flex align-items-end justify-content-end",
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-secondary",
                                            on: {
                                              click: function ($event) {
                                                return _setup.startSubscriptionCancelFlow()
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        Cancel " +
                                                _vm._s(
                                                  _setup.actionEntityStringCapitalized
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _setup.subscription &&
                            (_setup.subscription.Status === "paused" ||
                              _setup.subscription.Status === "paused_past_due")
                              ? _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-8" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _setup.actionEntityStringCapitalized
                                        ) +
                                        " is paused. To continue using our services\n                                    please resume it. You can also permanently cancel your " +
                                        _vm._s(_setup.actionEntityString) +
                                        ".\n                                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col d-flex align-items-end justify-content-end",
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-secondary",
                                          on: {
                                            click: function ($event) {
                                              return _setup.startSubscriptionCancelFlow()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        Cancel " +
                                              _vm._s(
                                                _setup.actionEntityStringCapitalized
                                              ) +
                                              "\n                                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _setup.subscription &&
                            _setup.hasActiveSubscription &&
                            _setup.subscription.WillCancelAt
                              ? _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-8" }, [
                                    _vm._v(
                                      "\n                                    Your " +
                                        _vm._s(_setup.actionEntityString) +
                                        " will be canceled on\n                                    "
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _setup.formatDateString(
                                            _setup.subscription.WillCancelAt
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(
                                      "\n                                    . You can avoid it by resuming your " +
                                        _vm._s(_setup.actionEntityString) +
                                        ".\n                                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col d-flex align-items-end justify-content-end",
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-primary",
                                          on: {
                                            click: function ($event) {
                                              return _setup.startSubscriptionResumeFlow()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        Resume " +
                                              _vm._s(
                                                _setup.actionEntityStringCapitalized
                                              ) +
                                              "\n                                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _setup.subscription &&
                            _setup.subscription.Status === "canceled"
                              ? _c("div", [
                                  _vm._v(
                                    "\n                                Your " +
                                      _vm._s(_setup.actionEntityString) +
                                      " has been canceled. Please contact us if you wish to\n                                resume using our services.\n                            "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_setup.subscription ||
                            (_setup.subscription &&
                              (_setup.subscription.Status === "unpaid" ||
                                _setup.subscription.Status === "incomplete" ||
                                _setup.subscription.Status ===
                                  "incomplete_expired"))
                              ? _c("div", [
                                  _vm._v(
                                    "\n                                You don't have any active subscriptions. Please contact us.\n                            "
                                  ),
                                ])
                              : _vm._e(),
                          ],
                    ],
                    2
                  ),
                ]),
              ]),
            ]),
          ])
        : _c("div", { staticClass: "mt-3" }, [_c(_setup.ShopifyBilling)], 1),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }